import * as yup from 'yup';

/**
 * E20 / E21 · Exposure — D-expectancies-2026-10-07 (founder Q-pbt-5 A): the both-ends codecs of the
 * optional "inhibitory learning" answers on `startExposition` / `finishExposition`.
 *
 * Authored ONCE, run on both ends: the phone and the portal validate before sending, the API
 * checks the closed vocabulary again. The LIKELIHOOD RANGE is the decider's rule as well
 * (`EXPOSITION_LIKELIHOOD_RANGE`); the server lets that one reach the decider so the refusal
 * carries the board's code, and these schemas are what stop a UI from ever sending it.
 *
 * Every answer is OPTIONAL and nullable: "not asked" is `undefined`/`null`, never 0 and never ''.
 */

export const EXPOSITION_OUTCOMES = ['yes', 'partly', 'no'] as const;
export type ExpositionOutcomeAnswer = (typeof EXPOSITION_OUTCOMES)[number];

/** A whole percentage, 0–100. */
export const expositionLikelihoodSchema = yup
  .number()
  .integer()
  .min(0)
  .max(100)
  .nullable();

export const expositionOutcomeSchema = yup
  .mixed<ExpositionOutcomeAnswer>()
  .oneOf([...EXPOSITION_OUTCOMES, null])
  .nullable();

export const startExpositionExpectancySchema = yup.object({
  expectedOutcome: yup.string().trim().nullable(),
  expectedLikelihood: expositionLikelihoodSchema,
});

export const finishExpositionOutcomeSchema = yup.object({
  outcomeOccurred: expositionOutcomeSchema,
  likelihoodAfter: expositionLikelihoodSchema,
  learned: yup.string().trim().nullable(),
});

export const exposureValidators = {
  expositionLikelihoodSchema,
  expositionOutcomeSchema,
  startExpositionExpectancySchema,
  finishExpositionOutcomeSchema,
};
